module.exports = __webpack_public_path__ + "252540238d35ed95e102fea532d32651.png";